import { normalizeReturnTo } from "./redirect";
import type { IDoceboLaunch } from "~/utils/interfaces/oidc-interfaces";

export function parseDoceboLaunch(value: string, referrer: string, embedded: boolean): IDoceboLaunch {
  if (!embedded || !referrer) throw new Error("Open this widget from Docebo");
  const parent = new URL(referrer);
  if (parent.protocol !== "https:" || parent.username || parent.password) throw new Error("Invalid Docebo parent");
  // Custom tenant domains are validated by the backend against the connector, not a frontend list.
  const url = new URL(value);
  const clientId = url.searchParams.get("client_id");
  const authCode = url.searchParams.get("auth_code");
  if (
    !clientId ||
    !authCode ||
    url.searchParams.getAll("client_id").length !== 1 ||
    url.searchParams.getAll("auth_code").length !== 1
  )
    throw new Error("Missing or invalid Docebo launch code");
  return {
    clientId,
    authCode,
    launchOrigin: parent.origin,
    returnTo: normalizeReturnTo(url.searchParams.get("next_url"), url.origin) ?? "/home",
  };
}
